import { TOPIC_CONTENT_SOURCES, type TopicContentSource } from "./topic-content-sources";

export const VISA_REFUSAL_CANCELLATION_SOURCES = [
  {
    sourceId: "visa-refusal-source-art-immigration",
    topicId: "visa-refusal-cancellation",
    title: "Immigration and citizenship",
    publisher: "Administrative Review Tribunal",
    url: "https://www.art.gov.au/applying-review/immigration-and-citizenship",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ART 공식 본문에서 review 가능한 일부 migration decisions, decision letter의 review right·신청자·strict time limit과 no-extension rule 확인",
    reviewStatus: "live_verified",
    claimScope: "visa refusal·cancellation ART review 가능성, 신청 정보와 엄격한 기한 확인",
    followUp: "결정문 수령 즉시 자신의 decision type, eligible applicant, exact deadline와 current fee를 ART에서 재확인",
  },
  {
    sourceId: "visa-refusal-source-art-apply",
    topicId: "visa-refusal-cancellation",
    title: "Applying for a review",
    publisher: "Administrative Review Tribunal",
    url: "https://www.art.gov.au/applying-review",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ART 공식 application 안내에서 online·other lodging channels, decision information, confirmation과 accessibility support 확인",
    reviewStatus: "live_verified",
    claimScope: "ART review application의 general lodging channel와 제출 확인",
    followUp: "online service availability, form, fee·reduction, identity와 decision-copy requirement를 lodging 당일 확인",
  },
  {
    sourceId: "visa-refusal-source-art-after",
    topicId: "visa-refusal-cancellation",
    title: "After you apply",
    publisher: "Administrative Review Tribunal",
    url: "https://www.art.gov.au/after-applying/after-you-apply",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ART 공식 본문에서 confirmation, original decision documents, new information, directions·hearing과 decision generally continuing 확인",
    reviewStatus: "live_verified",
    claimScope: "review application 후 correspondence, Department documents, evidence와 hearing 준비",
    followUp: "confirmation letter, case directions, document deadline와 any stay or urgent application requirement를 case별 확인",
  },
  {
    sourceId: "visa-refusal-source-art-outcomes",
    topicId: "visa-refusal-cancellation",
    title: "Possible outcomes",
    publisher: "Administrative Review Tribunal",
    url: "https://www.art.gov.au/after-applying/possible-outcomes",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ART 공식 본문에서 affirm, vary, set aside·substitute와 remit outcomes, reasons와 possible court pathway 확인",
    reviewStatus: "live_verified",
    claimScope: "ART review의 possible outcomes와 이후 legal pathway의 일반 범위",
    followUp: "decision 받은 즉시 reasons, effect, Department next step와 any court deadline을 lawyer에게 확인",
  },
  {
    sourceId: "visa-refusal-source-art-legal-help",
    topicId: "visa-refusal-cancellation",
    title: "Legal support",
    publisher: "Administrative Review Tribunal",
    url: "https://www.art.gov.au/help-and-resources/legal-support",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "ART 공식 legal-support 안내에서 Tribunal의 process help와 case advice 구분, external legal assistance 경로 확인",
    reviewStatus: "live_verified",
    claimScope: "review 과정의 independent migration·legal help와 representation 지원",
    followUp: "등록 migration agent·Australian lawyer status와 free legal-service eligibility를 즉시 확인",
  },
  {
    sourceId: "visa-refusal-source-no-valid-visa",
    topicId: "visa-refusal-cancellation",
    title: "If you don't have a valid visa",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/visas/visa-about-to-expire/if-you-dont-have-a-valid-visa",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Home Affairs 공식 본문에서 valid visa 없이 Australia에 머무르는 상태, status resolution과 official contact path 확인",
    reviewStatus: "live_verified",
    claimScope: "refusal·cancellation 후 valid visa가 없는 경우의 urgent status 확인과 공식 도움",
    followUp: "현재 visa·bridging status와 any departure, detention or application option을 즉시 Home Affairs·lawyer에게 확인",
  },
  {
    sourceId: "visa-refusal-source-vevo",
    topicId: "visa-refusal-cancellation",
    title: "Check visa conditions online (VEVO)",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/visas/already-have-a-visa/check-visa-details-and-conditions/check-conditions-online",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "Home Affairs 공식 본문에서 current visa details, expiry와 conditions 확인 기능 검토",
    reviewStatus: "live_verified",
    claimScope: "decision 전후 current visa·bridging visa와 work·study conditions 확인",
    followUp: "결정문·review application·travel·work change 전 current VEVO result와 grant notice를 다시 저장",
  },
] as const satisfies readonly TopicContentSource[];

const target = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of VISA_REFUSAL_CANCELLATION_SOURCES) {
  if (!target.some((item) => item.sourceId === source.sourceId)) target.push(source);
}
